import { ArrowLeftRight, DoorClosed, LucideIcon, Store, UserPlus } from "lucide-react";

const CATEGORIES: Record<string, { label: string; icon: LucideIcon; color: string }> = {
    opening:     { label: "Ouverture",   icon: Store,          color: "text-success" },
    closing:     { label: "Fermeture",   icon: DoorClosed,     color: "text-danger" },
    ownership:   { label: "Cession",     icon: ArrowLeftRight, color: "text-warning" },
    recruitment: { label: "Recrutement", icon: UserPlus,       color: "text-info" },
};

/**
 * A news item's category (opening, closing, sale, hiring) as a quiet neutral tag: white chip,
 * hairline border, muted label. The category's colour is kept to its icon only — a category is a
 * label, not a state, and full coloured pills read as consumer-app stickers next to the brand.
 */
export function NewsCategoryTag({ category, className = "" }: { category?: string | null; className?: string }) {
    const meta = category ? CATEGORIES[category] : undefined;
    if (!meta) return null;
    const Icon = meta.icon;
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-sm border border-border bg-surface px-2 py-1
                text-xs font-medium leading-none text-ink-muted whitespace-nowrap ${className}`}
        >
            <Icon className={`h-3 w-3 ${meta.color}`} strokeWidth={2.25} />
            {meta.label}
        </span>
    );
}
